import { useGuardToursQuery } from '@/graphql/generated/hooks'
import { GuardTourStatus } from '@/graphql/generated/schemas'

export enum TourStatus {
  COMPLETE = 'Complete',
  INCOMPLETE = 'Incomplete',
  IN_PROGRESS = 'In Progress',
  UNKNOWN = 'Unknown',
}

export type GuardToursRowDataType = {
  id: string
  facilityId: string
  facilityName: string
  facilityAddress: string
  tourPlanId: string
  tourPlan: string
  guardFullName: string
  submittedTime: string
  status: GuardTourStatus
}

export type GuardToursListType = ReturnType<
  typeof useGuardToursQuery
>['data']['guardTours']['edges']
